import NavigateBeforeIcon from '@portalterreno/react-ui-icons/NavigateBeforeIcon';
import NavigateNextIcon from '@portalterreno/react-ui-icons/NavigateNextIcon';
import { useTranslation } from 'next-i18next';
import React from 'react';

import ArrowButton from './ArrowButton';
import Container from './Container';
import PaginatorCounter from './PaginatorCounter';

export type PaginatorProps = {
  currentPage: number;
  limitPages: number;
  handleNextPage: () => void;
  handlePrevPage: () => void;
};
const Paginator: React.FC<PaginatorProps> = ({
  currentPage,
  limitPages,
  handleNextPage,
  handlePrevPage
}) => {
  const { t } = useTranslation('property');

  const beforeArrowVerification = React.useMemo(() => {
    if (currentPage === 1) {
      return true;
    }
    return false;
  }, [currentPage]);

  const nextArrowVerification = React.useMemo(() => {
    if (currentPage === limitPages) {
      return true;
    }
    return false;
  }, [currentPage, limitPages]);

  return (
    <Container>
      <PaginatorCounter
        variant='text'
        color='midnightBlue'
      >
        {t('relatedPropertiesPaginator', { currentPage, limitPages })}
      </PaginatorCounter>
      <ArrowButton
        color='secondary'
        onClick={handlePrevPage}
        disabled={beforeArrowVerification}
      >
        <NavigateBeforeIcon />
      </ArrowButton>
      <ArrowButton
        color='secondary'
        onClick={handleNextPage}
        disabled={nextArrowVerification}
      >
        <NavigateNextIcon />
      </ArrowButton>
    </Container>
  );
};

export default Paginator;
